var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.475,15.286A3.763,3.763,0,1,1,16.237,19,3.742,3.742,0,0,1,12.475,15.286Zm1.765,0a2,2,0,1,0,2-1.972A1.987,1.987,0,0,0,14.24,15.286ZM.883,16.157a.871.871,0,1,1,0-1.742H8.117a.871.871,0,1,1,0,1.742ZM0,3.713A3.742,3.742,0,0,1,3.762,0,3.743,3.743,0,0,1,7.525,3.713,3.743,3.743,0,0,1,3.762,7.428,3.742,3.742,0,0,1,0,3.713Zm1.765,0a2,2,0,1,0,2-1.972A1.987,1.987,0,0,0,1.765,3.713Zm10.118.871a.871.871,0,1,1,0-1.741h7.235a.871.871,0,1,1,0,1.741Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.be221926712f6449b7f4c06548059961.svg";
export { ForwardRef as ReactComponent };